<script lang="ts">
    import { _ } from "svelte-i18n"
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import { overlay } from "../../store"
    import { spaNavigate } from "../../functionTools/navigation"
    import { onMount, tick } from "svelte"

    let search: string = $state()
    let inputElement: HTMLInputElement

    onMount(async () => {
        await tick()
        setTimeout(() => {
            inputElement?.focus()
        }, 100)
    })
</script>

<div class="headline">{$_("mobile-search.headline")}</div>
<form
    class="form"
    onsubmit={(e) => {
        e.preventDefault()
        spaNavigate("/search?" + encodeURIComponent(search))
        $overlay.show = false
    }}
>
    <div class="input_holder">
        <label for="search" class="sr-only">{$_("mobile-search.placeholder")}</label>
        <input
            type="text"
            id="search"
            name="search"
            placeholder={$_("mobile-search.placeholder")}
            bind:value={search}
            bind:this={inputElement}
            required
        />
        <button type="submit" class="searchicon button primary">
            <MagnifyIcon />
        </button>
    </div>
</form>

<style lang="less">
    @import "../../css/variables.less";

    .headline {
        margin-bottom: 20px;
    }
    .form {
        width: 100%;
        button {
            width: 100%;
            .flex();
            align-items: center;
            justify-content: center;
        }
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
</style>
